var _defs, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelingAlignmentSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ModelingAlignment_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,2,28,2,27,2l-2,0L25,5.92A7,7,0,0,1,18,13H13.91a13,13,0,0,0-13,13v4h6V26a7,7,0,0,1,7-7H18A13,13,0,0,0,31,5.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelingAlignmentSvg);
export default __webpack_public_path__ + "static/media/ModelingAlignment_svg.68015c77b1d73e444503d8372df3c880.svg";
export { ForwardRef as ReactComponent };